import React, { useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'react-apollo';
import { Link } from 'react-router';
import A11y from 'chameleon/ui-stack/utilities/a11y';
import JstorConfirmModal from 'chameleon/ui-stack/ui/modals/jstor-confirm-modal/JstorConfirmModal';
import {
  handleTelemetry,
  TELEMETRY_EVENTS,
} from 'legacy-src/utility/telemetry';
import useLocalStorage from 'chameleon/ui-stack/ui/base/hooks/use-local-storage';
import { JSTOR_TERMS_AND_CONDITIONS } from 'chameleon/legacy/src/constants/types';
import {
  withMeQuery,
  withSavePreference,
} from 'chameleon/legacy/src/components/util';
import { savePreferenceSuccess as savePreferenceSuccessAction } from 'legacy/src/components/auth/actions';

const JstorLink = ({
  children,
  resource,
  subjectInfo,
  userData,
  ariaLabel,
  className,
  meQuery,
  savePreferenceSuccess,
  savePreference,
}) => {
  const { masterSubjectId: subjectId } = subjectInfo;
  const {
    chosenEducationPeriodCode: educationPeriod,
    me: { initId: studentInitId, preferences },
  } = userData;

  const [, , getAckTsFromLc] = useLocalStorage({
    key: `jstor-ts`,
    itemKey: `${studentInitId}-${educationPeriod}`,
    index: 1,
  });
  const [showModal, setShowModal] = useState(false);

  const preferenceValue = JSON.parse(
    (preferences || []).find(
      ({ preference }) => preference === JSTOR_TERMS_AND_CONDITIONS,
    )?.value || '{}',
  );

  // we keep checking localstorage for the first time
  const hasJstorAgreed =
    preferenceValue[educationPeriod] || getAckTsFromLc() === 'true';

  const { resourceId, url } = resource;
  const onLinkClick = (event) => {
    event.preventDefault();
    setShowModal(true);
  };

  const onClose = () => {
    setShowModal(false);
  };

  const onSuccess = () => {
    savePreference({
      variables: {
        userId: studentInitId,
        preference: JSTOR_TERMS_AND_CONDITIONS,
        value: JSON.stringify({
          ...preferenceValue,
          [educationPeriod]: 'true',
        }),
      },
    }).then(() => {
      meQuery.refetch().then(({ data }) => {
        savePreferenceSuccess(data.me);
      });

      setShowModal(false);

      handleTelemetry('course_guide', TELEMETRY_EVENTS.openJsTorResource, {
        resourceId,
        subjectId,
        educationPeriod,
      });

      if (!hasJstorAgreed) {
        handleTelemetry('course_guide', TELEMETRY_EVENTS.ackJsTorTerms, {
          resourceId,
          subjectId,
          educationPeriod,
        });
      }

      let win = window.open(url, '_blank');
      win.focus();
    });
  };

  return (
    <>
      {showModal ? (
        <JstorConfirmModal
          alreadyAgreed={hasJstorAgreed}
          studentInitId={studentInitId}
          onSuccess={onSuccess}
          onClose={onClose}
        />
      ) : null}
      <A11y>
        <Link
          tabIndex={0}
          className={className}
          onClick={onLinkClick}
          data-test-subunit-url
          data-cy="js-tor-link"
          target="_blank"
          url={url}
          aria-label={ariaLabel}
          onlyActiveOnIndex
        >
          {children}
        </Link>
      </A11y>
    </>
  );
};

export default compose(
  connect(
    ({ userData, subject }) => ({
      userData,
      subjectInfo: subject.data,
    }),
    { savePreferenceSuccess: savePreferenceSuccessAction },
  ),
  withSavePreference,
  withMeQuery,
)(JstorLink);
